// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TailwindMerge from "tailwind-merge";
import * as Tailwind$LiteracyplanetTupperware from "./Tailwind.res.mjs";

function PilotClozeDropBucketDisplay(props) {
  return React.createElement("div", {
              className: TailwindMerge.twMerge("grid", "gap-5", Tailwind$LiteracyplanetTupperware.makeGridCols(props.numColumns))
            }, props.children);
}

var make = PilotClozeDropBucketDisplay;

var $$default = PilotClozeDropBucketDisplay;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
